export default {"src":"/_next/static/media/dark-h.c2a44282.svg","height":39,"width":98,"blurWidth":0,"blurHeight":0};